import { Card, Typography } from "@mui/material";
import { Menstruation } from "../../types";
import { FC, useState } from "react";
import MenstruationDialog from "./MenstruationDialog";
import { grey } from "@mui/material/colors";
import {
  calcInclusiveDurationInDaysDisplay,
  formatDateRange,
} from "../../helpers";
import { DateTime } from "luxon";

interface MenstruationCardProps {
  menstruation: Menstruation;
  editMenstruation: (
    menstruationId: number,
    newMenstruation: { startDate: DateTime; endDate: DateTime },
  ) => void;
  deleteMenstruation: (menstruationId: number) => void;
}

const MenstruationCard: FC<MenstruationCardProps> = ({
  menstruation,
  editMenstruation,
  deleteMenstruation,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          padding: "0.5rem",
          cursor: "pointer",
          ":hover": { backgroundColor: grey[100] },
        }}
        onClick={handleOpen}
      >
        <Typography variant="body1">
          {formatDateRange(menstruation.startDate, menstruation.endDate)}{" "}
          <b>
            (
            {calcInclusiveDurationInDaysDisplay(
              menstruation.startDate,
              menstruation.endDate,
            )}
            )
          </b>
        </Typography>
      </Card>

      <MenstruationDialog
        providedMenstruation={menstruation}
        editMenstruation={editMenstruation}
        deleteMenstruation={deleteMenstruation}
        handleClose={handleClose}
        open={open}
        variant="edit"
      />
    </>
  );
};

export default MenstruationCard;
